import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/app/App'
import { installChunkErrorRecovery } from '@/shared/lib/chunk-recovery'
import '@/i18n'
import '@asus-common/fe-ui-shadcn/theme.css'
import '@/styles/globals.css'

installChunkErrorRecovery()

async function bootstrap() {
  if (import.meta.env.VITE_MOCK === 'true') {
    const { setupMocks } = await import('@/shared/api/mocks')
    setupMocks()
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

bootstrap()
